<template>
  <section :class="{active: fighter.name}" class="fighter-abilities">
    <div class="container">
      <AbilityColumn v-for="ability, index in types" :key=index :abilityData=getAbilities(ability) :abilityName=ability />
    </div>
  </section>
</template>

<script>
import AbilityColumn from '@/components/ui/fighters/AbilityColumn';

export default {
  name: 'FighterAbilities',
  props: ['fighter'],
  data() {
    return {
      types: ['basic_abilities', 'specials', 'supers']
    }
  },
  components: {
    AbilityColumn
  },
  methods: {
    getAbilities(ability) {
      return this.fighter[ability];
    },
    getHeader(ability) {
      return this.keys[ability]['header']
    }
  }
};
</script>

<style lang="scss">
  .fighter-abilities {
    opacity: 0;
    transition: 0.2s opacity ease-in-out;
    
    &.active {
      opacity: 1;
    }

    .container {

      @include bp($bp--l) {
        display: flex;
      }
    }
  }

  .ability-column {
    flex: 1;
    margin-bottom: 30px;

    @include bp($bp--m) {
      margin-bottom: 0;
    }
  }

  .ability-title {
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    font-size: 17px;
    position: relative;
    margin-bottom: 10px;
    background-size: contain;
    padding: 30px 0;
    margin-bottom: 30px;

    @include bp($bp--m) {
      padding: 50px 0;
      font-size: 28px;
      margin-bottom: 50px;
    }

    span {
      position: relative;
      z-index: 7;
    }
  }

  .header-background {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%,0);
    z-index: 6;
    max-width: 90%;

    @include bp(480px) {
      max-width: 350px;
    }

    @include bp($bp--m) {
      max-width: 95%;
    }
  }

  .ability-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 40px;

    @include bp($bp--m) {
      padding: 0 20px;
    }

    .h4,
    h4,
    p {
      color: #fff;
      font-size: 15px;

      @include bp($bp--m) {
        font-size: 16px;
      }
    }

    h4,
    .h4 {
      text-transform: uppercase;
      font-weight: bold;
      margin-bottom: 5px;
      line-height: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    p {
      line-height: 24px;
    }
  }
  .ability-meta {
    flex: 1;
  }
  .ability-image {
    width: 75px;
    margin-right: 20px;

    img {
      width: 100%;
      max-width: 53px;
    }

    // No padding
    &.image-wrapper {
      padding: 0;
    }
    .image-background {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/fighters/FighterAbilities.vue